(function () {
  var overlay = document.getElementById('age-gate-overlay');
  var yesBtn = document.getElementById('age-gate-yes');
  var noBtn = document.getElementById('age-gate-no');

  if (!overlay || !yesBtn || !noBtn) return;

  function closeOverlay() {
    try {
      localStorage.setItem('oc_age_verified', 'true');
    } catch (e) {}

    document.documentElement.style.overflow = '';
    overlay.classList.add('age-gate__overlay--exit');

    var hideOverlay = function () {
      overlay.setAttribute('hidden', '');
      overlay.style.display = 'none';
    };

    overlay.addEventListener('animationend', hideOverlay, { once: true });
    setTimeout(hideOverlay, 400);
  }

  yesBtn.addEventListener('click', closeOverlay);

  noBtn.addEventListener('click', function () {
    window.location.href = noBtn.getAttribute('data-exit-url');
  });
})();
